import React from "react";
import { getLangCode } from "../../config";
import { getString, setLangPreference } from "../../utilities";
import { language } from "../../config/constants";

export default function LocaleLink({ isCta }) {
  const langPref = getLangCode() === language.default ? language.la : language.default;

  return (
    <a
      role="link"
      onClick={() => {
        setLangPreference();
      }}
    >
      {getString(`${isCta ? "playInLocale.2" : `locale.${langPref}`}`)}
    </a>
  );
}
